import React, { useState, useRef } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { useInView } from 'framer-motion';
import { Plus, Minus } from 'lucide-react';
const faqs = [{
  question: 'Ya leí libros de autoayuda y no funcionaron',
  answer: 'Este no es un libro de autoayuda superficial. No hay frases motivacionales vacías. Es un proceso estructurado con ejercicios reales, casos reales y un componente espiritual que la mayoría ignora.'
}, {
  question: 'No tengo tiempo para leer',
  answer: 'Cada capítulo está diseñado para avanzar en bloques de 20 minutos. Esto no es para leer de corrido — es para vivir página por página, a tu ritmo.'
}, {
  question: '¿Esto es solo para personas religiosas?',
  answer: 'La fe es parte del proceso, pero el libro respeta tu camino. Si tienes dudas sobre Dios, también hay lugar para ti aquí. La pregunta no es si crees perfectamente — es si estás dispuesto a explorar.'
}, {
  question: 'Soy hombre y esto me parece muy emocional',
  answer: 'Los hombres que más necesitan esto son exactamente los que dicen eso. El libro fue escrito por un hombre que pasó por lo mismo. Sin juicio. Sin fórmulas. Solo verdad.'
}, {
  question: '¿Qué pasa si comienzo y abandono?',
  answer: 'El libro fue diseñado para eso. No hay fallo en volver. El capítulo 4 habla específicamente de que sanar no es lineal — y de cómo retomar sin destruirte por haberlo dejado.'
}];
export function FAQ() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section ref={ref} className="w-full bg-[var(--midnight)] py-24 md:py-32" data-id="element-102">
      <motion.div initial={{
      opacity: 0,
      y: 40
    }} animate={isInView ? {
      opacity: 1,
      y: 0
    } : {}} transition={{
      duration: 0.8
    }} className="max-w-4xl mx-auto px-6" data-id="element-103">
        <h2 className="font-display text-4xl md:text-5xl text-[var(--warm-gold)] text-center mb-16" data-id="element-104">
          Preguntas Frecuentes
        </h2>

        <div className="space-y-4" data-id="element-105">
          {faqs.map((faq, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} animate={isInView ? {
          opacity: 1,
          y: 0
        } : {}} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="bg-[var(--dusk-purple)]/20 rounded-xl border border-[var(--warm-gold)]/20 overflow-hidden" data-id="element-106">
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full flex items-center justify-between p-6 text-left hover:bg-[var(--dusk-purple)]/30 transition-colors" data-id="element-107">
                <span className="font-semibold text-lg text-[var(--cream)] pr-4" data-id="element-108">
                  {faq.question}
                </span>
                {openIndex === index ? <Minus className="w-5 h-5 text-[var(--warm-gold)] flex-shrink-0" data-id="element-109" /> : <Plus className="w-5 h-5 text-[var(--warm-gold)] flex-shrink-0" data-id="element-110" />}
              </button>

              <AnimatePresence data-id="element-111">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-112">
                    <div className="px-6 pb-6 text-[var(--cream)]/80 leading-relaxed" data-id="element-113">
                      {faq.answer}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </motion.div>)}
        </div>
      </motion.div>
    </section>;
}